import $ from "jquery";

const $accordionTemplate = $(`
     <div class="accordion" id="accordion">
       <div class="panel accordion-group">
         <div class="accordion-heading" role="tab" id="headingOne">
             <a role="button" id="accordion-head" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne"></a>
         </div>
         <div id="collapseOne" class="accordion-body collapse" role="tabpanel" aria-labelledby="headingOne">
           <div class="accordion-inner"></div>
         </div>
       </div>
    </div>`);
const $accordionMobTemplate = $(`
     <div class="accordion" id="accordion-mob">
       <div class="panel accordion-group">
         <div class="accordion-mob-heading" role="tab" id="headingMobOne">
             <a role="button" id="accordion-mob-head" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseMobOne" aria-expanded="true" aria-controls="collapseMobOne"></a>
         </div>
         <div id="collapseMobOne" class="accordion-body collapse" role="tabpanel" aria-labelledby="headingMobOne">
           <div class="accordion-inner"></div>
         </div>
       </div>
    </div>`);

export default function filters() {
    const createFilterNav = function () {
        let $navAccordion = $('.filter-nav-accordion');
        let $navMobAccordion = $('.filter-mob-nav-accordion');
        $navAccordion.html('');
        $navMobAccordion.html('');
        let firstToInsert = true;
        $('.productmanager-filter').each(function (i) {
            const $filterSelect = $(this);
            let $accordion = $accordionTemplate.clone();
            let $accordionMobile = $accordionMobTemplate.clone();
            /* Accordion */
            $accordion.attr('id', 'accordion-filter-' + i);
            /* Accordion headline */
            $accordion.find('#headingOne')
                .attr('id', 'heading-filter-' + i)
                .find('#accordion-head')
                .attr('id', 'accordion-head-' + i)
                .attr('href', '#collapse-filter-' + i)
                .attr('aria-controls', 'collapse-filter-' + i)
                .attr('data-parent', '#accordion-filter-' + i)
                .text($(this).data('label'));
            /* Accordion body */
            $accordion
                .find('#collapseOne')
                .attr('aria-labelledby', 'heading-filter-' + i)
                .attr('id', 'collapse-filter-' + i);

            /* Accordion Mobile */
            $accordionMobile.attr('id', 'accordion-mob-filter-' + i);
            /* Accordion Mobile headline */
            $accordionMobile.find('#headingMobOne')
                .attr('id', 'heading-mob-filter-' + i)
                .find('#accordion-mob-head')
                .attr('id', 'accordion-mob-head-' + i)
                .attr('href', '#collapse-mob-filter-' + i)
                .attr('aria-controls', 'collapse-mob-filter-' + i)
                .attr('data-parent', '#accordion-mob-filter-' + i)
                .text($(this).data('label'));
            /* Accordion  Mobilebody */
            $accordionMobile
                .find('#collapseMobOne')
                .attr('aria-labelledby', 'heading-mob-filter-' + i)
                .attr('id', 'collapse-mob-filter-' + i);
            let addedFilterLink = false;
            let hasActiveLink = false;

            $(this).find('option').each(function () {
                const disabled = $(this).prop('disabled');
                if (disabled) {
                    // like continue
                    return;
                }
                addedFilterLink = true;
                const selected = $(this).prop('selected');
                const filterValue = $(this).val();
                const filterLink = $(`<p class="filter-option-wrapper"><a href="" class="filter-option ${selected ? 'active' : ''}" >${selected ? '<span class="close"></span>' : ''}${$(this).data('label')}</a></p>`);

                if(!hasActiveLink) {
                    hasActiveLink = !!selected;
                }
                filterLink.find('a').on('click', function (e) {
                    e.preventDefault();
                    let newValue;
                    if ($(this).hasClass('active')) {
                        let currentValues = $filterSelect.select2().val();
                        newValue = currentValues.filter(e => e !== filterValue);
                    } else {
                        newValue = $filterSelect.select2().val().concat(filterValue)
                    }
                    $filterSelect.select2().val(newValue).trigger("change");
                    filterLink.find('a').off('click');
                    ProductManager.Main.on('LAZY_LOADING_REQUEST_COMPLETE', createFilterNav);
                    return false;
                });
                const filterLinkMob = filterLink.clone(true, true);
                $accordion.find('.accordion-inner').append(filterLink);
                $accordionMobile.find('.accordion-inner').append(filterLinkMob);
            });
            if (addedFilterLink) {
                if (firstToInsert || hasActiveLink) {
                    firstToInsert = false;
                    $accordion.find('.collapse').addClass('in');
                    $accordionMobile.find('.collapse').addClass('in');
                } else {
                    $accordion.find('.accordion-toggle').addClass('collapsed');
                    $accordionMobile.find('.accordion-toggle').addClass('collapsed');
                }
                $navAccordion.append($accordion);
                $navMobAccordion.append($accordionMobile);
            }
        });
    };

    // initial load
    createFilterNav();
    setTimeout(function () {
        ProductManager.Main.on('LAZY_LOADING_REQUEST_COMPLETE', createFilterNav);
    }, 200);
}
